var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-date-picker',_vm._g(_vm._b({ref:"elDatePicker",attrs:{"type":_vm.type,"range-separator":"至","picker-options":_vm.pickerOptions}},'el-date-picker',_vm.$attrs,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }